/** Las mismas órdenes aplicadas a la copia en memoria: la interfaz cambia al instante, antes de que llegue a Google. */
import type { Workbook } from './parse.js';
import type { Command } from './write.js';

const upsert = <T extends { id: string }>(list: T[], item: T) =>
  list.some(x => x.id === item.id) ? list.map(x => (x.id === item.id ? item : x)) : [...list, item];

export function applyLocally(wb: Workbook, cmd: Command): Workbook {
  switch (cmd.type) {
    case 'upsert-session': return { ...wb, sessions: upsert(wb.sessions, cmd.session) };
    case 'delete-session': return { ...wb, sessions: wb.sessions.filter(s => s.id !== cmd.id) };
    case 'upsert-wingchun': return { ...wb, hasWingChunTab: true, wingChun: upsert(wb.wingChun, cmd.practice) };
    case 'delete-wingchun': return { ...wb, wingChun: wb.wingChun.filter(p => p.id !== cmd.id) };
    case 'set-setting': return { ...wb, settings: { ...wb.settings, [cmd.key]: cmd.value } };
    case 'replace-routine': return { ...wb, routine: cmd.rows };
  }
}
